import styled from 'styled-components';
// eslint-disable-next-line import/no-extraneous-dependencies
import { rem } from 'polished';

// eslint-disable-next-line import/prefer-default-export
export const CanvasStyled = styled.div`
  max-width:${rem(2000)};
  margin: 0 auto;
  overflow-x: hidden;
`;
